import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "AppBootPushNotifications" */ './lazyFunctions'),
    { name: 'AppBootPushNotifications' }
);

export const lazyUnsubscribeToNativePushNotificationProxy: LazyAction<
    typeof lazyFunctions.lazyUnsubscribeToNativePushNotification.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyUnsubscribeToNativePushNotification.importAndExecute);
